import { useMemo } from 'react';
import { omit } from 'lodash-es';
import { SendToDeereButton } from '../../../../components/deere/SendToDeereButton';
import { RxOptions } from '../RxOptions';
import { useContext } from '../../context';

export function DeereButton() {
  const { tab, getSelectedPrescriptions } = useContext();
  const isInstancesTab = tab === 'instances';

  const prescriptions = useMemo(() => {
    const selected = getSelectedPrescriptions();
    return Object.values(selected).flat();
  }, [getSelectedPrescriptions]);

  return (
    <SendToDeereButton
      type="lpk"
      pattern={`{fieldName}_{product}_{year}${isInstancesTab ? '_{instance}' : ''}`}
      prescriptions={prescriptions}
      prescriptionMapper={(options, rx) => {
        if (!options?.elements?.includes(rx.symbol)) return null;

        return {
          ...omit(rx, ['aaid']),
          nutrient: rx.type,
          product: rx.symbol,
          instance: isInstancesTab ? rx.instance?.name : null,
        };
      }}
      Options={RxOptions}
    />
  );
}
